<style lang="scss">
.mdm-setup {
}
</style>

<template>
  <!-- Error page-->
  <div>
    <div v-if="loading" class="d-flex flex-column justify-content-center align-items-center mt-5">
      <h1>Verifying details, please wait...</h1>

      <b-spinner variant="primary" label="Loading" />
    </div>

    <h1 v-else>You do not have valid access to this app</h1>
  </div>
  <!-- / Error page-->
</template>

<script>
import LogsService from '@/services/LogsService';

export default {
  components: {},
  data() {
    return {
      loading: true,
    }
  },
  computed: {},
  mounted() {
    // uncomment for test
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwcmlzb25faWQiOiJkZjdmN2JlMjExNzM0YTkwOGMzOTc1Zjk2YTNjMmFiMCIsInByaXNvbmVyX251bWJlciI6IkExMTExRkYiLCJ0eXBlIjoiTWRtVXNlciJ9.kN-MxZ4Nyx7vvITZ-yPRAqtQGMh_dTZZ6C60_fQRUQc';
    // this.$store.dispatch('auth/setLocalUserToken', token);

    // listen for a custom electron event
    window.addEventListener('electronSetup', data => {
      const Token = data.detail.token;
      if (Token) {
        this.$store.commit('SET_IS_ELECTRON', true);
        this.$store.dispatch('auth/setLocalUserToken', Token);

        setTimeout(() => {
          LogsService.convertMdmToken(Token).then(res => {
            console.log('converted token', res);
            this.$store.dispatch('auth/setLocalUserToken', res.data.token);
            this.$store.dispatch('sendStat', { meta: {}, description: 'Opened Purple Visits App' });
            this.$router.push({ name: 'dashboard' });
          }).catch(err => {
            console.log('You do not have valid access', err);
            this.loading = false;
          });
        });
      }
    });
  },
}
</script>
